export default __webpack_public_path__ + "slices/main/assets/public/media/chapters-card-1@2x.05e547444387f29f14df0b82634bf2b6.png";